<template>
  <v-row justify-center>
    <v-dialog v-model="translateFlag" id="translateFlag" persistent max-width="650">
      <v-card>
        <!-- <v-card-title class="headline">{{ this.$t('popUpTranslate.titulo') }}</v-card-title> -->
        <v-container fluid>
          <o-big-title>{{ this.$t('popUpTranslate.titulo') }}</o-big-title>
        </v-container>
        <v-row justify="start" align="center" dense class="ml-10 mr-10">
            <v-col cols="12">
                <v-text-field
                    v-model="spa" 
                    id="spa"
                    :label="this.$t('popUpTranslate.espanol')"
                    color="primary"
                    :disabled="idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 1"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="eng" 
                    id="eng"
                    :label="this.$t('popUpTranslate.ingles')"
                    color="primary"
                    :disabled="idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 1"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="eus" 
                    id="eus"
                    :label="this.$t('popUpTranslate.euskera')"
                    color="primary"
                    :disabled="idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 1"
                />
            </v-col>
            <v-col cols="12">
                <v-text-field
                    v-model="cat"
                    :label="this.$t('popUpTranslate.catalan')"
                    color="primary"
                />
            </v-col>
        </v-row>
        <v-card-actions class="justify-center">
          <v-spacer></v-spacer>
          <v-btn class="primary" @click="$emit('cancel')">{{ this.$t('popUpTranslate.cerrar') }}</v-btn>
          <v-btn class="primary" @click="guardar()" v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">{{ this.$t('popUpTranslate.guardar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    translateFlag: Boolean,
    translateDialog: Boolean,
    idMaestro: null,
    tipoMaestro: null
  },
  data () {
    return {
      spa: '',
      eng: '',
      eus: '',
      cat: ''
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    }
  },
  methods: {
    ...mapActions({
      getTranslates: "incidencias/getTranslates",
    }),
    guardar () {
      let values = {
        'eng': this.eng,
        'spa': this.spa,
        'eus': this.eus,
        'cat': this.cat
      }
      this.$emit('save', values)
    },
    
  },
  watch: {
    async translateFlag() {
      this.spa = ''
      this.eng = ''
      this.eus = ''
      this.cat = ''
      if ( this.translateFlag === true) {
        await this.getTranslates({ id: this.idMaestro, tipoMaestro: this.tipoMaestro })
        this.spa = this.$store.state.incidencias.translates.spa
        this.eng = this.$store.state.incidencias.translates.eng
        this.eus = this.$store.state.incidencias.translates.eus
        this.cat = this.$store.state.incidencias.translates.cat
      }
      
    }
  }
}
</script>

<style scoped>
.center-icon {
  text-align: center;
}
.amber--text {
  font-size: 90px !important;
}
</style>